"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pxToNum = function pxToNum(val) {
  return parseInt(val.slice(0, -2), 10);
};
exports.pxToNum = pxToNum;


//////////////////
// WEBPACK FOOTER
// ./~/react-burger-menu/lib/helpers/utils.js
// module id = 136
// module chunks = 114276838955818